export type ChoiceOption = { readonly id: string; readonly label: string };

export type ChoiceField =
  | {
      readonly kind: "single";
      readonly key: string;
      readonly label: string;
      readonly options: readonly ChoiceOption[];
    }
  | {
      readonly kind: "multi";
      readonly key: string;
      readonly label: string;
      readonly count: number;
      readonly options: readonly ChoiceOption[];
    }
  | {
      readonly kind: "dependent";
      readonly key: string;
      readonly label: string;
      readonly options: readonly ChoiceOption[];
      readonly reveal: Readonly<Record<string, readonly ChoiceField[]>>;
    };

export type FeatOptionDto = {
  readonly id: string;
  readonly label: string;
  readonly needsConfig: boolean;
  readonly configKind?: "asi" | "skill-chooser" | "dependent-choice";
  readonly choiceFields?: readonly ChoiceField[];
};

export type OriginFeatOption = FeatOptionDto;

const FEAT_ENDPOINTS = {
  origin: "/api/origin-feats",
  general: "/api/general-feats",
  fightingStyle: "/api/fighting-style-feats",
} as const;

export async function fetchFeatOptions(
  pool: keyof typeof FEAT_ENDPOINTS
): Promise<FeatOptionDto[]> {
  const res = await fetch(FEAT_ENDPOINTS[pool]);
  if (!res.ok) {
    throw new Error(`Failed to fetch ${pool} feats`);
  }
  return res.json();
}

export function fetchOriginFeats(): Promise<OriginFeatOption[]> {
  return fetchFeatOptions("origin");
}
